export default {"src":"/_next/static/media/business-transaction-icon.4ded58c1.svg","height":80,"width":120,"blurWidth":0,"blurHeight":0};